module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/favorites-2f8676f4d85f653774cb9ed5268d531f.webp";